import axiosClient from 'api/axiosClient';
import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import DialogRejectEnergyBillView from 'features/Charge/ChargeEnergyBill/components/DialogRejectEnergyBillView';
import DialogSendFeedbackView from 'features/Charge/ChargeEnergyBill/components/DialogSendFeedbackView';
import { ChargeConstants } from 'features/Charge/chargeHelper';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import { dateFilter, getDateFilterOption } from 'general/components/Others/CustomDateRangePicker';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import AppResource from 'general/constants/AppResource';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import moment from 'moment';
import DialogChangePasswordView from './Account/components/DialogChangePasswordView';
import DialogUpdateAccountView from './Account/components/DialogUpdateAccountView';

export const SystemConstants = {
  UserStatus: {
    REGISTERED: 'REGISTERED', // da dang ky (cho kich hoat)
    NORMAL: 'NORMAL', // dang hoat dong
    SUSPENDED: 'SUSPENDED', // ngung hoat dong
    DELETED: 'DELETED', // da xoa
  },
  EnergyBillStatus: {
    MISSING: 'MISSING', // chua gui
    PENDING: 'PENDING', // cho phe duyet
    VALIDATED: 'VALIDATED', // hop le
    REJECTED: 'REJECTED', // khong hop le
  },
};

const SystemHelper = {
  // MARK: ---- DATA ----
  Data: {
    UserStatusOptions: [
      { name: 'Chờ kích hoạt', value: SystemConstants.UserStatus.REGISTERED },
      { name: 'Đang hoạt động', value: SystemConstants.UserStatus.NORMAL },
      { name: 'Ngừng hoạt động', value: SystemConstants.UserStatus.SUSPENDED },
      { name: 'Đã xóa', value: SystemConstants.UserStatus.DELETED },
    ],
    EnergyBillStatusOptions: [
      { name: 'Chưa gửi', value: SystemConstants.EnergyBillStatus.MISSING },
      { name: 'Chờ phê duyệt', value: SystemConstants.EnergyBillStatus.PENDING },
      { name: 'Hợp lệ', value: SystemConstants.EnergyBillStatus.VALIDATED },
      { name: 'Không hợp lệ', value: SystemConstants.EnergyBillStatus.REJECTED },
    ],
    UserPositionOptions: [
      { name: 'Tổng giám đốc', value: 'CEO' },
      { name: 'Phó giám đốc', value: 'VICE_DIRECTOR' },
      { name: 'Trưởng phòng kinh doanh', value: 'SALES_MANAGER' },
      { name: 'Nhân viên kinh doanh', value: 'SALES_STAFF' },
      { name: 'Trưởng phòng CSKH', value: 'CUSTOMER_SERVICE_MANAGER' },
      { name: 'Nhân viên CSKH', value: 'CUSTOMER_SERVICE_STAFF' },
      { name: 'Trưởng phòng kỹ thuật phần mềm', value: 'SOFTWARE_ENGINEERING_MANAGER' },
      { name: 'Nhân viên kỹ thuật phần mềm', value: 'SOFTWARE_ENGINEER' },
      { name: 'Trưởng phòng kỹ thuật hạ tầng', value: 'INFRA_ENGINEERING_MANAGER' },
      { name: 'Nhân viên kỹ thuật hạ tầng', value: 'INFRA_ENGINEER' },
      { name: 'Trưởng phòng kế toán', value: 'ACCOUNTING_MANAGER' },
      { name: 'Nhân viên kế toán', value: 'ACCOUNTANT' },
      { name: 'Trưởng phòng HCNS', value: 'HR_ADMIN_MANAGER' },
      { name: 'Nhân viên HCNS', value: 'HR_ADMIN_STAFF' },
    ],
  },

  // MARK: ---- FILTERS ----
  Filter: {
    staffList: {
      role: '',
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: '',
      status: '',
    },
    poaContractList: {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: '',
      status: '',
      dateFilter: dateFilter.baMuoiNgayGanNhat,
      from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
      to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
    },
    pushNotificationList: {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: '',
      category: '',
      userId: '',
      createdBy: 'USER',
      from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
      to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
      dateFilter: dateFilter.baMuoiNgayGanNhat,
      isSent: '',
    },
    energyBillList: {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: '',
      month: moment().format('YYYY-MM'),
      status: '',
      managedBy: '',
      agencyId: '',
      landlordId: '',
    },
    actionLogList: {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: '',
      category: '',
      userId: '',
      from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
      to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
      dateFilter: dateFilter.baMuoiNgayGanNhat,
    },
  },

  // MARK: ---- API ----
  API: {
    // MARK: ---- USER ----
    User: {
      // lay danh sach tai khoan
      requestGetUserList: async (params) => {
        const url = '/user';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, users, total } = response;
          if (result === 'success') {
            return { users, total };
          }
          return { users: [], total: 0 };
        } catch (error) {
          return { users: [], total: 0 };
        }
      },
      // them tai khoan
      requestAddUser: async (params) => {
        const url = '/user/create';
        try {
          const response = await axiosClient.post(url, params);
          const { result, reason } = response;
          if (result === 'success') {
            return true;
          }
          return reason;
        } catch (error) {
          return error?.response?.data?.reason || 'Thêm tài khoản thất bại';
        }
      },
      // cap nhat tai khoan
      requestUpdateUser: async (userId, params) => {
        const url = `/user/${userId}`;
        try {
          const response = await axiosClient.put(url, params);
          const { result, reason } = response;
          if (result === 'success') {
            return true;
          }
          return reason;
        } catch (error) {
          return error?.response?.data?.reason || 'Cập nhật tài khoản thất bại';
        }
      },
      // xoa tai khoan
      requestDeleteUser: async (userId) => {
        const url = `/user/${userId}`;
        try {
          const response = await axiosClient.delete(url);
          const { result, reason } = response;
          if (result === 'success') {
            return true;
          }
          return reason;
        } catch (error) {
          return error?.response?.data?.reason || 'Xóa tài khoản thất bại';
        }
      },
    },
    // MARK: ---- PERMISSION ----
    Permission: {
      // lay danh sach nhom quyen
      requestGetPermissionGroupList: async (params) => {
        const url = '/permission';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, permissionGroups, permissions } = response;
          if (result === 'success') {
            return { permissionGroups, permissions };
          }
          return { permissionGroups: [], permissions: [] };
        } catch (error) {
          return { permissionGroups: [], permissions: [] };
        }
      },
      // them nhom quyen
      requestAddPermissionGroup: async (params) => {
        const url = '/permission/create';
        try {
          const response = await axiosClient.post(url, params);
          const { result, reason } = response;
          if (result === 'success') {
            return true;
          }
          return reason;
        } catch (error) {
          return error?.response?.data?.reason || 'Thêm nhóm quyền thất bại';
        }
      },
      // cap nhat nhom quyen
      requestUpdatePermissionGroup: async (permissionGroupId, params) => {
        const url = `/permission/${permissionGroupId}`;
        try {
          const response = await axiosClient.put(url, params);
          const { result, reason } = response;
          if (result === 'success') {
            return true;
          }
          return reason;
        } catch (error) {
          return error?.response?.data?.reason || 'Cập nhật nhóm quyền thất bại';
        }
      },
      // xoa nhom quyen
      requestDeletePermissionGroup: async (permissionGroupId) => {
        const url = `/permission/${permissionGroupId}`;
        try {
          const response = await axiosClient.delete(url);
          const { result, reason } = response;
          if (result === 'success') {
            return true;
          }
          return reason;
        } catch (error) {
          return error?.response?.data?.reason || 'Xóa nhóm quyền thất bại';
        }
      },
    },
    // MARK: ---- CONFIG ----
    Config: {
      // cap nhat config
      requestUpdateConfig: async (params) => {
        const url = '/config';
        try {
          const response = await axiosClient.post(url, params);
          const { result, reason } = response;
          if (result === 'success') {
            return true;
          }
          return reason;
        } catch (error) {
          return error?.response?.data?.reason || 'Cập nhật cấu hình thất bại';
        }
      },
    },
    // MARK: ---- ACCOUNT ----
    Account: {
      // doi mat khau
      requestChangePassword: async (params) => {
        const url = '/user/changePassword';
        try {
          const response = await axiosClient.post(url, params);
          const { result, reason } = response;
          if (result === 'success') {
            return true;
          }
          return reason;
        } catch (error) {
          return error?.response?.data?.reason || 'Đổi mật khẩu thất bại';
        }
      },
      // cap nhat thong tin tai khoan
      requestUpdateAccountInfo: async (userId, params) => {
        const url = `/user/${userId}`;
        try {
          const response = await axiosClient.put(url, params);
          const { result, reason } = response;
          if (result === 'success') {
            return true;
          }
          return reason;
        } catch (error) {
          return error?.response?.data?.reason || 'Cập nhật thông tin tài khoản thất bại';
        }
      },
    },
    // MARK: ---- SOC ----
    SOC: {
      requestGetSocData: async (params) => {
        const url = '/dashboard/soc';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, soc } = response;
          if (result === 'success') {
            return soc;
          }
          return {};
        } catch (error) {
          return {};
        }
      },
    },
    // MARK: ---- ENERGY BILL ----
    EnergyBill: {
      requestGetAll: async (params) => {
        const url = '/energyBill/all';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, energyBills, total } = response;
          if (result === 'success') {
            return { energyBills, total };
          }
          return { energyBills: [], total: 0 };
        } catch (error) {
          return { energyBills: [], total: 0 };
        }
      },
      requestGetByMonth: async (params) => {
        const url = '/energyBill/month';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, chargeStations, total, month } = response;
          if (result === 'success') {
            return { chargeStations, total, month };
          }
          return { chargeStations: [], total: 0, month: '' };
        } catch (error) {
          return { chargeStations: [], total: 0, month: '' };
        }
      },
      // lay chi tiet hoa don
      requestGetEnergyBillDetail: async (billId) => {
        const url = `/energyBill/${billId}`;
        try {
          const response = await axiosClient.get(url);
          const { result, energyBill } = response;
          if (result === 'success') {
            return energyBill;
          }
          return null;
        } catch (error) {
          return null;
        }
      },
      // tao hoa don
      requestCreateEnergyBill: async (params) => {
        const url = '/energyBill/create';
        try {
          const response = await axiosClient.post(url, params);
          const { result, reason } = response;
          if (result === 'success') {
            return true;
          }
          return reason;
        } catch (error) {
          return error?.response?.data?.reason || 'Tạo hoá đơn thất bại';
        }
      },
      // cap nhat hoa don
      requestUpdateEnergyBill: async (billId, params) => {
        const url = `/energyBill/${billId}`;
        try {
          const response = await axiosClient.put(url, params);
          const { result, reason } = response;
          if (result === 'success') {
            return true;
          }
          return reason;
        } catch (error) {
          return error?.response?.data?.reason || 'Cập nhật hoá đơn thất bại';
        }
      },
      // xoa hoa don
      requestDeleteEnergyBill: async (billId) => {
        const url = `/energyBill/${billId}`;
        try {
          const response = await axiosClient.delete(url);
          const { result, reason } = response;
          if (result === 'success') {
            return true;
          }
          return reason;
        } catch (error) {
          return error?.response?.data?.reason || 'Xóa hoá đơn thất bại';
        }
      },
    },
    // MARK: ---- AUDIT ----
    // lay danh sach nhat ky hoat dong
    requestGetAuditList: async (params) => {
      const url = `/audit`;
      try {
        const response = await axiosClient.get(url, { params });
        const { result, audits, total } = response;
        if (result === 'success') {
          return { audits, total };
        }
        return null;
      } catch (error) {
        return null;
      }
    },
  },

  // MARK: ---- UI ----
  UI: {
    // MARK: ---- USER ----
    User: {
      // dialog xac nhan xoa tai khoan
      showDialogConfirmDeleteUser: (user, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
            title="Xoá nhân viên"
            contentEl={
              <>
                Bạn có chắc muốn xoá nhân viên{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {user?.fullname}
                </span>
                ?
              </>
            }
            cancelButtonText="Bỏ qua"
            confirmButtonText="Xoá"
            confirmButtonRed={true}
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await SystemHelper.API.User.requestDeleteUser(user?.userId);
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Xoá nhân viên thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Xoá nhân viên thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // dialog xac nhan ngung hoat dong tai khoan
      showDialogConfirmSuspendUser: (user, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogStopAgency} />}
            title="Ngừng hoạt động"
            contentEl={
              <>
                Bạn có chắc muốn ngừng hoạt động nhân viên{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {user?.fullname}
                </span>{' '}
                không?
              </>
            }
            cancelButtonText="Bỏ qua"
            confirmButtonText="Ngừng hoạt động"
            confirmButtonRed={true}
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await SystemHelper.API.User.requestUpdateUser(user?.userId, {
                status: SystemConstants.UserStatus.SUSPENDED,
              });
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Ngừng hoạt động thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Ngừng hoạt động thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // dialog xac nhan khoi phuc hoat dong tai khoan
      showDialogConfirmResumeUser: (user, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogActiveAgency} />}
            title="Khôi phục hoạt động"
            contentEl={
              <>
                Bạn có chắc muốn khôi phục hoạt động nhân viên{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {user?.fullname}
                </span>{' '}
                không?
              </>
            }
            cancelButtonText="Bỏ qua"
            confirmButtonText="Khôi phục hoạt động"
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await SystemHelper.API.User.requestUpdateUser(user?.userId, {
                status: SystemConstants.UserStatus.NORMAL,
              });
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Khôi phục hoạt động thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Khôi phục hoạt động thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // dialog xac nhan gan uy quyen tai khoan
      showDialogConfirmSetPoaUser: (user, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogSetPoa} />}
            title="Gán uỷ quyền"
            contentEl={
              <>
                Bạn có chắc muốn gán uỷ quyền cho nhân viên{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {user?.fullname}
                </span>{' '}
                không?
              </>
            }
            cancelButtonText="Bỏ qua"
            confirmButtonText="Gán uỷ quyền"
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await SystemHelper.API.Config.requestUpdateConfig({
                key: 'poaUserId',
                value: user?.userId,
              });
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Gán uỷ quyền thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Gán uỷ quyền thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // dialog xac nhan huy uy quyen tai khoan
      showDialogConfirmUnsetPoaUser: (user, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogUnsetPoa} />}
            title="Hủy uỷ quyền"
            contentEl={
              <>
                Bạn có chắc muốn hủy uỷ quyền nhân viên{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {user?.fullname}
                </span>{' '}
                không?
              </>
            }
            cancelButtonText="Bỏ qua"
            confirmButtonText="Hủy uỷ quyền"
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await SystemHelper.API.Config.requestUpdateConfig({
                key: 'poaUserId',
                value: null,
              });
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Hủy uỷ quyền thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Hủy uỷ quyền thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
    },
    // MARK: ---- ACCOUNT ----
    Account: {
      // hien dialog xac nhan dang xuat
      showDialogConfirmSignOut: (onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            title="Đăng xuất"
            contentEl={<>Bạn thực sự muốn đăng xuất khỏi hệ thống?</>}
            cancelButtonText="Bỏ qua"
            confirmButtonText="Đăng xuất"
            confirmButtonRed={true}
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={() => {
              AppCustomDialogHelper.hide();
              onDone();
            }}
            iconEl={<img src={AppResource.images.dialogIcons.dialogSignOut} />}
          />,
          'md',
          true,
          true
        );
      },
      // hien dialog doi mat khau
      showDialogChangePassword: (onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            title="Đổi mật khẩu"
            contentEl={<>Thay đổi mật khẩu đăng nhập hệ thống của bạn</>}
            iconEl={<img src={AppResource.images.dialogIcons.dialogChangePassword} />}
            bodyEl={
              <DialogChangePasswordView
                onCancel={() => {
                  AppCustomDialogHelper.hide();
                }}
                onDone={() => {
                  AppCustomDialogHelper.hide();
                  if (onDone) {
                    onDone();
                  }
                }}
              />
            }
            removeFooter={true}
          />,
          'md',
          false,
          true
        );
      },
      // hien dialog cap nhat thong tin tai khoan
      showDialogUpdateAccountInfo: (user, onDone) => {
        AppCustomDialogHelper.show(
          'Cài đặt tài khoản',
          <DialogUpdateAccountView
            user={user}
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onDone={() => {
              AppCustomDialogHelper.hide();
              if (onDone) {
                onDone();
              }
            }}
          />,
          'lg',
          false,
          true
        );
      },
    },
    // MARK: ---- PERMISSION ----
    Permission: {
      // hien dialog xac nhan xoa nhom quyen
      showDialogConfirmDeletePermissionGroup: (permissionGroup, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
            title="Xoá nhóm quyền"
            contentEl={
              <>
                Bạn có chắc muốn xoá nhóm quyền{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {permissionGroup?.name}
                </span>
                ?
              </>
            }
            cancelButtonText="Bỏ qua"
            confirmButtonText="Xoá"
            confirmButtonRed={true}
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await SystemHelper.API.Permission.requestDeletePermissionGroup(
                permissionGroup?.permissionGroupId
              );
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Xoá nhóm quyền thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Xoá nhóm quyền thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
    },
    // MARK: ---- ENERGY BILL ----
    EnergyBill: {
      // hien dialog xac nhan hop le hoa don
      showDialogConfirmValidate: (row, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogSuccess} />}
            title="Xác nhận hợp lệ"
            contentEl={
              <>
                Bạn có chắc muốn xác nhận hoá đơn{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {row?.evnCustomerId}
                </span>{' '}
                là hợp lệ không?
              </>
            }
            cancelButtonText="Hủy bỏ"
            confirmButtonText="Xác nhận"
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await SystemHelper.API.EnergyBill.requestUpdateEnergyBill(
                row?.billId,
                {
                  status: SystemConstants.EnergyBillStatus.VALIDATED,
                }
              );
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Xác nhận hợp lệ thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Xác nhận hợp lệ thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // hien dialog xac nhan khong hop le hoa don
      showDialogConfirmReject: (row, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogError} />}
            title="Xác nhận không hợp lệ"
            contentEl={
              <>
                Vui lòng nhập lý do hóa đơn không hợp lệ
              </>
            }
            bodyEl={
              <DialogRejectEnergyBillView
                item={row}
                onCancel={() => {
                  AppCustomDialogHelper.hide();
                }}
                onDone={() => {
                  AppCustomDialogHelper.hide();
                  if (onDone) {
                    onDone();
                  }
                }}
              />
            }
            removeFooter={true}
          />,
          'md',
          true,
          true
        );
      },
      // hien dialog phan hoi hoa don
      showDialogConfirmFeedback: (row, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogFeedback} />}
            title="Gửi phản hồi"
            contentEl={<>Vui lòng nhập nội dung thông tin bạn muốn phản hồi tới nhà điều hành</>}
            bodyEl={
              <DialogSendFeedbackView
                item={row}
                onCancel={() => {
                  AppCustomDialogHelper.hide();
                }}
                onDone={() => {
                  AppCustomDialogHelper.hide();
                  if (onDone) {
                    onDone();
                  }
                }}
              />
            }
            removeFooter={true}
          />,
          'md',
          true,
          true
        );
      },
      // hien dialog xem phan hoi hoa don
      showDialogViewFeedback: (row) => {
        const feedback = row?.feedback;
        AppCustomDialogHelper.show(
          'Chi tiết phản hồi',
          <AgencySaleDialogView
            cancelButtonText="Bỏ qua"
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            confirmButtonText={null}
            onlyBodyEl={true}
            bodyEl={
              <div className="p-4" style={{ backgroundColor: AppColors.gray[100] }}>
                <div
                  className="bg-white p-4"
                  style={{
                    borderRadius: '5px',
                    border: `1px solid ${AppColors.gray[300]}`,
                  }}
                >
                  {Utils.isValid(feedback) ? (
                    <span
                      className="text-left"
                      style={UIHelper.buildFontStyle('500', '13px', AppColors.gray[800])}
                    >
                      {feedback}
                    </span>
                  ) : (
                    <div>{UIHelper.buildEmptyNoData('Không có phản hồi nào')}</div>
                  )}
                </div>
              </div>
            }
          />,
          'md',
          false,
          true
        );
      },
      // hien dialog xem ly do khong hop le
      showDialogViewRejectReason: (row) => {
        const reason = row?.rejectReason;
        AppCustomDialogHelper.show(
          'Lý do không hợp lệ',
          <AgencySaleDialogView
            cancelButtonText="Bỏ qua"
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            confirmButtonText={null}
            onlyBodyEl={true}
            bodyEl={
              <div className="p-4" style={{ backgroundColor: AppColors.gray[100] }}>
                <div
                  className="bg-white p-4"
                  style={{
                    borderRadius: '5px',
                    border: `1px solid ${AppColors.gray[300]}`,
                  }}
                >
                  {Utils.isValid(reason) ? (
                    <span
                      className="text-left"
                      style={UIHelper.buildFontStyle('500', '13px', AppColors.gray[800])}
                    >
                      {reason}
                    </span>
                  ) : (
                    <div>{UIHelper.buildEmptyNoData('Không có nội dung')}</div>
                  )}
                </div>
              </div>
            }
          />,
          'md',
          false,
          true
        );
      },
    },
  },

  // MARK: ---- UTILS ----
  Utils: {
    // MARK: ---- USER ----
    User: {
      // ten trang thai user
      getUserStatusName: (status) => {
        switch (status) {
          case SystemConstants.UserStatus.REGISTERED:
            return 'Chờ kích hoạt';
          case SystemConstants.UserStatus.NORMAL:
            return 'Đang hoạt động';
          case SystemConstants.UserStatus.SUSPENDED:
            return 'Ngừng hoạt động';
          case SystemConstants.UserStatus.DELETED:
            return 'Đã xóa';
          default:
            return '';
        }
      },
      // mau trang thai user
      getUserStatusColor: (status) => {
        switch (status) {
          case SystemConstants.UserStatus.REGISTERED:
            return 'info';
          case SystemConstants.UserStatus.NORMAL:
            return 'success';
          case SystemConstants.UserStatus.SUSPENDED:
            return 'secondary';
          case SystemConstants.UserStatus.DELETED:
            return 'danger';
          default:
            return '';
        }
      },
    },
    // MARK: ---- SOC ----
    SOC: {
      getSocSystemLogIcon: (type) => {
        switch (type) {
          case ChargeConstants.MessageLogType.INFO:
            return 'fa-solid fa-circle-info';
          case ChargeConstants.MessageLogType.ERROR:
            return 'fa-solid fa-triangle-exclamation';
          case ChargeConstants.MessageLogType.NOTICE:
            return 'fa-solid fa-message-lines';
          case ChargeConstants.MessageLogType.WARNING:
            return 'fa-solid fa-message-exclamation';
          default:
            return '';
        }
      },
      getSocSystemLogColor: (type) => {
        switch (type) {
          case ChargeConstants.MessageLogType.INFO:
            return 'rgba(30, 245, 223, 1)';
          case ChargeConstants.MessageLogType.ERROR:
            return 'rgba(245, 35, 29, 1)';
          case ChargeConstants.MessageLogType.NOTICE:
            return 'rgba(41, 132, 238, 1)';
          case ChargeConstants.MessageLogType.WARNING:
            return 'rgba(249, 183, 0, 1)';
          default:
            return '';
        }
      },
      getSocPointStatusColor: (status) => {
        switch (status) {
          case ChargeConstants.ChargePointStatus.AVAILABLE:
            return 'rgba(48, 189, 111, 1)';
          case ChargeConstants.ChargePointStatus.MAINTAINING:
            return 'rgba(255, 157, 28, 1)';
          case ChargeConstants.ChargePointStatus.FAULT:
            return 'rgba(225, 78, 84, 1)';
          case ChargeConstants.ChargePointStatus.BUSY:
            return 'rgba(126, 130, 153, 1)';
          case ChargeConstants.ChargePointStatus.DISCONNECTED:
            return 'rgba(189, 48, 50, 1)';
          default:
            return '';
        }
      },
      getSocStationStatusColor: (status) => {
        switch (status) {
          case ChargeConstants.ChargeStationStatus.HIDDEN:
            return 'rgba(126, 78, 167, 1)';
          case ChargeConstants.ChargeStationStatus.MAINTAINING:
            return 'rgba(203, 159, 0, 1)';
          case ChargeConstants.ChargeStationStatus.NORMAL:
            return 'rgba(96, 189, 1, 1)';
          case ChargeConstants.ChargeStationStatus.PENDING:
            return 'rgba(24, 119, 231, 1)';
          case ChargeConstants.ChargeStationStatus.STOPPED:
            return 'rgba(142, 142, 142, 1)';
          default:
            return '';
        }
      },
    },
    // MARK: ---- ENERGY BILL ----
    EnergyBill: {
      getEnergyBillStatusName: (status) => {
        switch (status) {
          case SystemConstants.EnergyBillStatus.MISSING:
            return 'Chưa gửi';
          case SystemConstants.EnergyBillStatus.PENDING:
            return 'Chờ phê duyệt';
          case SystemConstants.EnergyBillStatus.VALIDATED:
            return 'Hợp lệ';
          case SystemConstants.EnergyBillStatus.REJECTED:
            return 'Không hợp lệ';
          default:
            return '';
        }
      },
      getEnergyBillStatusColor: (status) => {
        switch (status) {
          case SystemConstants.EnergyBillStatus.MISSING:
            return 'secondary';
          case SystemConstants.EnergyBillStatus.PENDING:
            return 'warning';
          case SystemConstants.EnergyBillStatus.VALIDATED:
            return 'success';
          case SystemConstants.EnergyBillStatus.REJECTED:
            return 'danger';
          default:
            return '';
        }
      },
    },
  },
};

export default SystemHelper;
